import { motion } from 'framer-motion';
import { fadeInUp } from '../../utils/motionVariants';

const ExperienceCard = ({ exp, index, reduceMotion }) => {
  if (!exp) return null;
  const badge = exp.badge || null;

  return (
    <motion.article
      variants={fadeInUp(0.05 * index, reduceMotion ? 0 : 24)}
      className="glass-panel glass-panel-hover px-6 py-6 sm:px-7 sm:py-7"
    >
      <header className="mb-3">
        <h3 className="text-base sm:text-lg font-bold tracking-tight text-gray-900 leading-snug">
          {exp.role}
        </h3>
        <p className="text-emerald-600 font-semibold mt-1 text-sm">
          {exp.company}
        </p>
        <p className="text-xs font-medium text-gray-400 mt-0.5 tabular-nums">
          {exp.period}
        </p>
      </header>

      {badge && (
        <span className="inline-flex items-center rounded-full bg-emerald-50 text-emerald-700 px-3 py-0.5 text-[11px] font-semibold tracking-wide border border-emerald-100">
          {badge}
        </span>
      )}
    </motion.article>
  );
};

export default ExperienceCard;
